import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDossier: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dossier"><path d="M2 7.75C2 5.67893 3.67893 4 5.75 4H8V9.5H22V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75Z" fill="currentColor"/><path d="M9.5 4H15V8H9.5V4Z" fill="currentColor"/><path d="M16.5 4H18.25C20.3211 4 22 5.67893 22 7.75V8H16.5V4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDossier;
